module.exports = __webpack_public_path__ + "static/media/join.15470863.svg";